var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bg-cl-white body-box dp-flex jtf-ct-center al-it-center f-drt-column"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-100pct bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"
        },
        [_vm._v("\n    ตั้งค่าสาขา\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-80pct mg-vtc-10px" },
        [
          _c(
            "b-select",
            {
              attrs: { expanded: "" },
              model: {
                value: _vm.selectBranch,
                callback: function($$v) {
                  _vm.selectBranch = $$v
                },
                expression: "selectBranch"
              }
            },
            [
              _c("option", { attrs: { value: "", disabled: "" } }, [
                _vm._v("เลือกสาขา")
              ]),
              _vm._v(" "),
              _vm._l(_vm.branchs, function(branch, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: branch } },
                  [_vm._v("\n        " + _vm._s(branch.name) + "\n      ")]
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectBranch !== ""
        ? _c(
            "div",
            { staticClass: "w-80pct mg-vtc-10px" },
            [
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.selectPOS,
                    callback: function($$v) {
                      _vm.selectPOS = $$v
                    },
                    expression: "selectPOS"
                  }
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v("POS ID")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.selectBranch.posID, function(pos, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(pos) +
                            "( " +
                            _vm._s(
                              _vm.selectBranch.posWarehouseDisplayName[index]
                            ) +
                            " )\n      "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-80pct mg-vtc-10px pd-vtc-10px bg-cl-black cl-white cs-pointer bd-rd-4px f-w-bold t-al-center"
        },
        [
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  _vm.confirmSelect()
                }
              }
            },
            [_vm._v("\n      ตกลง\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _vm.cancelBtn
        ? _c(
            "div",
            {
              staticClass:
                "w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold"
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.cancel()
                    }
                  }
                },
                [_vm._v("\n      ยกเลิก\n    ")]
              )
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold t-al-center"
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("\n      ออกจากระบบ\n    ")]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2d872ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2d872ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/selectStore.vue
// module id = 348
// module chunks = 1